export enum CreateEditJobNavEnum {
  JOB_FOR = 'Customer',
  JOB_DETAILS = 'Job Details',
  JOB_SCHEDULE = 'Schedule & Assign To',
  LINE_ITEMS = 'Line Items',
  NOTES_ATTACHMENTS = 'Notes & Attachments',
  MORE_OPTIONS = 'More Options'
}

export const jobSearchTypes = [
  {
    id: 'search-option-job-title',
    text: 'Job title',
    searchText: 'Search with job title',
    type: 'title'
  },
  {
    id: 'search-option-customer',
    text: 'Customer',
    searchText: 'Search with customer',
    type: 'customer'
  },
  {
    id: 'search-option-reference-id',
    text: 'Reference ID',
    searchText: 'Search with reference ID',
    type: 'referenceId'
  },
  {
    id: 'search-option-line-items',
    text: 'Line items',
    searchText: 'Search with line items',
    type: 'lineItems'
  },
  {
    id: 'search-option-invoice-id',
    text: 'Invoice ID',
    searchText: 'Search with invoice ID',
    type: 'invoices'
  }
  // TODO: Add estimate ID search option after estimate is done
  // ,
  //   {
  //     id: 'search-option-estimate-id',
  //     text: 'Estimate ID',
  //     searchText: 'Search with estimate ID',
  //     type: 'estimateID'
  //   }
];

export enum JobStatus {
  SUBMITTED = 'SUBMITTED',
  CONFIRMED = 'CONFIRMED',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  PENDING = 'PENDING',
  DONE_PENDING_APPROVAL = 'DONE_PENDING_APPROVAL',
  CANCELED = 'CANCELED',
  ARCHIVED = 'ARCHIVED',
  REJECTED = 'REJECTED',
  INBOX = 'INBOX'
}

export enum LeadSource {
  THUMBTACK = 'thumbtack',
  REFERRAL = 'referral',
  GOOGLE = 'google',
  YELP = 'yelp',
  FACEBOOK = 'facebook',
  WEBSITE = 'website',
  OTHER = 'other'
}
export enum JobsFilterType {
  OVERDUE = 'overdue',
  NEXT_7_DAYS = 'next7days',
  UNSCHEDULED = 'unscheduled'
}

export const JobsStatuses = [
  {
    label: 'Inbox',
    value: JobStatus.INBOX
  },
  {
    label: 'Submitted',
    value: JobStatus.SUBMITTED
  },
  {
    label: 'Confirmed',
    value: JobStatus.CONFIRMED
  },
  {
    label: 'In progress',
    value: JobStatus.IN_PROGRESS
  },
  {
    label: 'Done pending approval',
    value: JobStatus.DONE_PENDING_APPROVAL
  },
  {
    label: 'Done',
    value: JobStatus.DONE
  },
  {
    label: 'Pending',
    value: JobStatus.PENDING
  },
  {
    label: 'Canceled',
    value: JobStatus.CANCELED
  },
  {
    label: 'Archived',
    value: JobStatus.ARCHIVED
  }
];

export const JobLeadSourceTypes = [
  {
    label: 'Thumbtack',
    value: LeadSource.THUMBTACK,
    hasSource: false
  },
  {
    label: 'Referral',
    value: LeadSource.REFERRAL,
    hasSource: true,
    inputPlaceholder: 'Enter referrer name'
  },
  {
    label: 'Google',
    value: LeadSource.GOOGLE,
    hasSource: false
  },
  {
    label: 'Yelp',
    value: LeadSource.YELP,
    hasSource: false
  },
  {
    label: 'Facebook',
    value: LeadSource.FACEBOOK,
    hasSource: false
  },
  {
    label: 'Website',
    value: LeadSource.WEBSITE,
    hasSource: false
  },
  {
    label: 'Other',
    value: LeadSource.OTHER,
    hasSource: true,
    inputPlaceholder: 'Enter source name'
  }
];

export const LeadSourceOptions = JobLeadSourceTypes.map(item => ({ id: item.value, name: item.label }));

export enum JOB_TAB_TITLE {
  ALL_JOBS = 'All jobs',
  PENDING = 'Pending',
  IN_PROGRESS = 'In progress',
  TO_BE_STARTED = 'To be started'
}

export const jobTabs = [
  {
    id: 1,
    title: JOB_TAB_TITLE.TO_BE_STARTED
  },
  {
    id: 2,
    title: JOB_TAB_TITLE.PENDING
  },
  {
    id: 3,
    title: JOB_TAB_TITLE.IN_PROGRESS
  },
  {
    id: 4,
    title: JOB_TAB_TITLE.ALL_JOBS
  }
];

export const defaultJobStatusCount = {
  [JOB_TAB_TITLE.ALL_JOBS]: 0,
  [JOB_TAB_TITLE.PENDING]: 0,
  [JOB_TAB_TITLE.IN_PROGRESS]: 0,
  [JOB_TAB_TITLE.TO_BE_STARTED]: 0
};

export enum JOB_ATTRIBUTE_TYPE {
  REFERENCE_ID = 'referenceId'
}

export enum CreateJobErrorTypes {
  JOB_TITLE = 'jobtitle',
  LEAD_SOURCE = 'leadSource',
  EXTERNAL_COMPANY = 'externalCompany',
  CUSTOMER = 'customer',
  SERVICE_ADDRESS = 'serviceAddress',
  SERVICE_ADDRESS_MISSING_FIELDS = 'serviceAddressMissingFields',
  SCHEDULE_DATE = 'scheduleDate',
  ASSIGN_MEMBER = 'assignMember',
  SCHEDULE_TIME = 'scheduleTime',
  JOB_SOURCE = 'jobSource',
  CREATE_EXTERNAL_COMPANY = 'createExternalCompany'
}

export const createJobErrors = {
  jobtitle: 'Job title cannot be empty',
  leadSource: 'Lead source cannot be empty',
  customer: 'Customer cannot be empty',
  serviceAddress: 'Service address cannot be empty',
  serviceAddressMissingFields: 'Some fields are missing in service address.',
  scheduleDate: 'Schedule cannot be empty',
  scheduleTime: 'Start time should be less than end time',
  assignMember: 'Assigned team cannot be empty',
  createExternalCompany: 'Please create external company to continue.'
};

export enum CreateJobButtonIds {
  CREATE_BUTTON = 'create-edit-job-save-button',
  CREATE_BACK_BUTTON = 'create-edit-job-back-button',
  AUTO_FILL_BUTTON = 'create-edit-job-auto-fill-button'
}

export enum ExpenseCategories {
  MATERIAL = 'Material',
  TRAVEL = 'Travel',
  EQUIPMENT = 'Equipment',
  OVERHEAD = 'Overhead',
  OTHER = 'Other'
}

export const ExpenseCategoriesOptions = [
  {
    id: ExpenseCategories.MATERIAL,
    name: ExpenseCategories.MATERIAL
  },
  {
    id: ExpenseCategories.TRAVEL,
    name: ExpenseCategories.TRAVEL
  },
  {
    id: ExpenseCategories.EQUIPMENT,
    name: ExpenseCategories.EQUIPMENT
  },
  {
    id: ExpenseCategories.OVERHEAD,
    name: ExpenseCategories.OVERHEAD
  },
  {
    id: ExpenseCategories.OTHER,
    name: ExpenseCategories.OTHER
  }
];

export enum JobSSEEvents {
  JOB_UPDATED = 'job_updated',
  JOB_NOTE_UPDATED = 'job_note_updated'
}
